import NavBar from "./NavBar";
import telefonoProdotti from "../data/telefonoProdotti.json"
import bigiotteriaProdotti from "../data/bigiotteriaProdotti.json"
import casaProdotti from "../data/casaProdotti.json"
import { useEffect,useState } from "react";
import Footer from "./Footer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";

export default function Catalogo(){


    //array per i prodotti
    const objects = [];
    //mettere prodotti in objects
    function inp(prodotti){
        for (const tipo in prodotti) {
            if (prodotti.hasOwnProperty(tipo)) {
                const sottoTipi = prodotti[tipo];
                for (const prodotti in sottoTipi) {
                    if (sottoTipi.hasOwnProperty(prodotti)) {
                        const items = sottoTipi[prodotti];
                        if(!prodotti.includes("overView")){
                            objects.push(...items);
                        }
                        
                    }
                }
            }
        }
    }
    inp(telefonoProdotti);
    inp(bigiotteriaProdotti);
    inp(casaProdotti);



    const [valoreCercato,setValoreCercato] = useState("");
    const [ordine,setOrdine] = useState("0");
    const [arr,setArr] = useState([...objects])
    
    useEffect(()=>{
        const data = window.localStorage.getItem("VALORE_CERCATO")
        if(data!== null) setValoreCercato(JSON.parse(data))
    },[])

    useEffect(() => {
        window.localStorage.setItem("VALORE_CERCATO",JSON.stringify(valoreCercato))
    }, [valoreCercato])

    function controlla(arr,vC){
        const arrVC = vC.toLowerCase().split(" ");
        let flag = true;
        let stringa = arr.join(" ")
        stringa = stringa.toLowerCase();
        arrVC.forEach(elem=>{
            if(!stringa.includes(elem)){
                flag = false;
            }
        })
        
        return flag;
    }
    function cambiato(n){
        setOrdine(n);
        if(n==="1"){
            pCrescente();
            return ordine;
        }
        if(n==="2"){
            pDecrescente();
            return ordine;
        }
        if(n==="3"){
            pAlfabetico();
            return ordine
        }
        setArr([...objects])
    }
    function pCrescente(){

        setArr(arr.sort((a,b)=>{
            return a.prezzo-b.prezzo
        }))
    }
    function pDecrescente(){
        setArr(arr.sort((a,b)=>{
            return b.prezzo-a.prezzo
        }))
    }
    function pAlfabetico(){
        setArr(arr.sort((a,b)=>{
            if(a.titolo<b.titolo){
                return -1;
            }
            if(a.titolo>b.titlo){
                return 1;
            }
            return 0;
        }))
    }

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
        <div className="catalogoBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Informazioni" due="Prodotti" tre="Contattaci" one="/informazioni" two="/prodotti" three="/contattaci"/>
            <div className="catalogoDiv">
                <h1 style={{paddingTop:"15px",margin:"15px",marginTop:"25px"}}>Catalogo</h1>

                <div className="barraRicerca">
                    <label htmlFor="ricerca" style={{textAlign:"left"}}>Filtra</label>
                    <input type="text" id="ricerca" placeholder="parola chiave" value={valoreCercato} onChange={event => setValoreCercato(event.target.value)} autoComplete="off"/>
                    <select name="" id="" onChange={e => cambiato(e.target.value)}>
                        <option value="0">Ordina per...</option>
                        <option value="1">Prezzo ↓</option>
                        <option value="2">Prezzo ↑</option>
                        <option value="3">Alfabetico</option>
                    </select>
                </div>

                {/* <h2 style={{margin:"0 auto",marginTop:"2rem"}}>Prodotti per telefono</h2> */}

                <div className="catalogoProdotti">
                    
                    { arr && arr
                        .filter((elem)=>
                        {
                            if(valoreCercato.trim()===""){
                                return elem;
                                    
                            }else if(controlla(elem.id,valoreCercato)){
                                return elem;
                            }
                            return null
                            
                            
                        }
                        )
                        .map((elem)=>{
                            return(
                                <Link className="catalogoProdottoSingolo" key={elem.id} to={`../prodotti/${elem.urlLink[0]}-${elem.urlLink[1]}-${elem.urlLink[2]}-${elem.urlLink[3]}-${(elem.titolo).split(" ").join("_")}`}>
                                    <h2 className="titoloProdottoSingolo">{elem.titolo}</h2>
                                    <img src={elem.immagine[0]} alt="immagine" />
                                    <p className="prezzoProdottoSingolo">€{elem.prezzo}</p>
                                    <p className="descrizioneProdottoSingolo">{elem.descrizione}</p>
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
        </div>
        <Footer />
        </>
    )
}